module.exports = "/_next/static/images/Flutternashik-0bab76eef96e13501cc255b97efb3166.jpg";